const run_code_2x = () => { 
const observer_2x = new MutationObserver(() => {
  const target = document.querySelector('#variant-2');
  if (target) {
    const variant = document.querySelector('#variant-2');
    if (!variant) return;
    variant.checked = true;
    variant.dispatchEvent(new Event('change', { bubbles: true }));
    const formVariantInput = document.querySelector('form.shopify-product-form input[name="id"]');
    if (formVariantInput) {
      formVariantInput.value = variant.value;
    }
    observer_2x.disconnect();
  }
});

observer_2x.observe(document.body, {
  childList: true,
  subtree: true
});
};

if (document.readyState === "loading") {
document.addEventListener("DOMContentLoaded", run_code_2x);
} else {
run_code_2x();
}